import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
    wrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 4,
        padding: "12px 16px",
        cursor: "pointer",
        fontSize: 20,
        lineHeight: "24px",
        fontWeight: 400,
    },
    filterIcon: {
        width: 16,
        height: 16,
        marginRight: 8,
    },
    label: {
        fontSize: 20,
        lineHeight: "24px",
        fontWeight: 400,
        color: "#F5F5F599",
    },
});
